import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { environment } from '@environment';
import { patchState, signalState } from '@ngrx/signals';
import { firstValueFrom } from 'rxjs';
import { Attendance, AttendanceRecord, PatchAttendanceRecord } from '~/domain/types/attendance';

type State = {
  isoDate: string;
  attendance: Attendance | null;
};

@Service()
export class AttendanceService {
  private readonly _http = inject(HttpClient);
  private readonly _state = signalState<State>({
    isoDate: 'today',
    attendance: null,
  });

  readonly isoDate = this._state.isoDate;
  readonly attendance = this._state.attendance;

  async loadAttendance(isoDate: string): Promise<void> {
    patchState(this._state, { isoDate });

    const attendance = await firstValueFrom(this._http.get<Attendance>(`${environment.api}/attendance/${isoDate}`));
    patchState(this._state, { attendance });
  }

  fetchAttendanceRecord(isoDate: string, employeeId: string): Promise<AttendanceRecord> {
    return firstValueFrom(this._http.get<AttendanceRecord>(`${environment.api}/attendance/${isoDate}/${employeeId}`));
  }

  patchAttendanceRecord(isoDate: string, employeeId: string, data: PatchAttendanceRecord): Promise<AttendanceRecord> {
    const body = data;

    return firstValueFrom(
      this._http.patch<AttendanceRecord>(`${environment.api}/attendance/${isoDate}/${employeeId}`, body),
    );
  }
}
